import { FieldErrors, Path } from 'react-hook-form';
import { IGcfComponentConfig, IThemeRes } from 'src/interfaces';

export interface IHeaderTextStylingAccordion {
  componentConfig: IGcfComponentConfig;
  handleOnChange: (keys: Path<IGcfComponentConfig>, value: unknown) => void;
  errors: FieldErrors<IGcfComponentConfig>;
  enableIndividualStyles?: boolean;
  theme?: IThemeRes;
  hidden?: HeaderTextStylingOptions[];
}

export enum HeaderTextStylingOptions {
  HEADER = 'header',
  HEADER_LAYOUT = 'headerLayout',
  SUBHEADER = 'subHeader',
  DISCLAIMER = 'disclaimer',
  MOLECULE = 'molecule',
  MOLECULE_DISPLAY_LABEL = 'moleculeDisplayLabel',
}
